<template lang="pug">
  .sidebar-overlay-slide.from-top(ref="menu",:class='{"show": isShow}')
    ul.sidebar-system-menu.clearfix
      li(
        v-for="(nav,index) in navTree"
        :style="nav|style",
        @click="changeSystem(nav)"
      ) {{nav.label}}
</template>

<script>
import IScroll from 'iscroll'
export default {
  name: 'SystemMenu',
  props: {
    navTree: Array,
    isShow: Boolean
  },
  data () {
    return {}
  },
  mounted () {
    this.$nextTick(() => {
      this.initScroll()
    })
  },
  methods: {
    changeSystem: function (nav) {
      this.$emit('changeSystem', nav.url)
    },
    initScroll () {
      if (this.menuScroll) {
        this.menuScroll.destroy()
        this.menuScroll = null
      }
      this.menuScroll = new IScroll(this.$refs.menu, {
        scrollbars: true,
        mouseWheel: true,
        interactiveScrollbars: true,
        shrinkScrollbars: 'scale',
        fadeScrollbars: false,
        click: true
      })
    }
  },
  filters: {
    style (nav) {
      return {
        background: nav.color || '#10cfbd'
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.sidebar-overlay-slide
  overflow: hidden
  .sidebar-system-menu
    padding: 5px
    list-style: none
    li
      display: inline-block
      width: 80px
      height: 80px
      margin: 10px 5px
      font-size: 15px
      // font-weight: bold
      text-align: center
      line-height: 84px
      color: #fff
      cursor: pointer
</style>



// WEBPACK FOOTER //
// SystemMenu.vue?24e6bd86